(function ($, undefined) {
  /*============================================
  Right sidebar
  ==============================================*/
  $(function () {
    const sidepanel = document.getElementById("right_side");

    $('.js-open-right-side').click(function () {
      if (sidepanel) {
        sidepanel.style.right = "0";
      } else {
        console.error("Error: Side panel element not found!");
      }
    })

    $('.js-close-right-side').click(function () {
      if (sidepanel) {
        sidepanel.style.right = "-355px";
      } else {
        console.error("Error: Side panel element not found!");
      }
    })
  });

  /*============================================
  Nav panel
  ==============================================*/
  $(function () {
    const navPanel = document.getElementById("mySidenav");

    $('.js-open-nav-panel').click(function () {
      if (navPanel) {
        navPanel.style.width = "280px";
      } else {
        console.error("Error:Nav panel element not found!");
      }
    })

    $('.js-close-nav-panel').click(function () {
      if (navPanel) {
        navPanel.style.width = "0";
      } else {
        console.error("Error:Nav panel element not found!");
      }
    })
  });

  /*============================================
  button back to top
  ==============================================*/
  $(function () {
    $('.js-scroll-to-top').click(function () {
      const scrollToTopBtn = document.documentElement || document.body;
      scrollToTopBtn.scrollIntoView({
        behavior: "smooth"
      });
    })

    window.onscroll = function () {
      scrollFunction()
    };

    function scrollFunction() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById("backToTopBtn").style.display = "block";
      } else {
        document.getElementById("backToTopBtn").style.display = "none";
      }
    }
  });
})(jQuery);
